import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
//Utils
import PublicRouter from './utils/public_router';
//Components
import Page from './components/page/page';
import ErrorPage from './components/page/error_page';
import Index from './pages/index';
import Landing from './pages/landing';
import Error from './pages/sessions/error/error';
//
//
export default function App() {
    //
    const branding = 'E V O L U I R';
    const globalTitle = 'Sempre Buscando - ' + branding;
    const menuList = [
        {
            url: 'sobre',
            label: 'O Curso'
        },
        {
            url: 'testemunhas',
            label: 'Quem Conheceu'
        },
        {
            url: 'roadmap',
            label: 'Trilha'
        },
        {
            url: 'promo',
            label: 'Lotes'
        },
        {
            url: 'time',
            label: 'Facilitadores'
        },
        {
            url: 'contato',
            label: 'Contato'
        }
    ];
    //
    return (
        <BrowserRouter>
            <Switch>
                {/* O Root -> Landing Page*/}
                <PublicRouter path="/" component={Page({ container: Index, component: Landing, label: globalTitle, title: 'Home', branding: branding, menuList: menuList })} exact />
                {/* Error Page */}
                <PublicRouter component={ErrorPage({ component: Error, label: globalTitle, title: '404', error: '404' })} />
            </Switch>
        </BrowserRouter>
        
    );
}